import { Navigate } from "react-router-dom";
import { urls } from "@/urls";

export const adminRoutes = {
  async lazy() {
    const { AdminRoot } = await import("./Root");
    return { Component: AdminRoot };
  },
  children: [
    {
      path: urls.admin.dashboard,
      async lazy() {
        const { Dashboard } = await import("./layout/Dashboard");
        return { Component: Dashboard };
      },
    },
    {
      path: urls.admin.client,
      async lazy() {
        const { ClientRequest } = await import("./layout/ClientRequest");
        return { Component: ClientRequest };
      },
    },
    {
      path: urls.admin.knowledge_base,
      async lazy() {
        const { KnowledgeBase } = await import("./layout/KnowledgeBase.tsx");
        return { Component: KnowledgeBase };
      },
    },
    {
      // 報價知識庫列表已併入「知識庫」頁的分頁，舊書籤導向該分頁
      path: urls.admin.pricing_kb,
      element: (
        <Navigate to={`${urls.admin.knowledge_base}?tab=pricing`} replace />
      ),
    },
    {
      path: urls.admin.pricing_kb_detail,
      async lazy() {
        const { PricingKnowledgeBaseDetailPage } = await import(
          "./layout/PricingKnowledgeBaseDetailPage"
        );
        return { Component: PricingKnowledgeBaseDetailPage };
      },
    },
    {
      path: urls.admin.knowledge_base_case,
      async lazy() {
        const { KnowledgeBaseCasePage } = await import(
          "./layout/KnowledgeBaseCasePage.tsx"
        );
        return { Component: KnowledgeBaseCasePage };
      },
    },
    {
      path: urls.admin.presentation_templates,
      async lazy() {
        const { PresentationTemplates } = await import(
          "./layout/PresentationTemplates"
        );
        return { Component: PresentationTemplates };
      },
    },
    {
      path: urls.admin.demo,
      async lazy() {
        const { ClientRequestDemo } = await import(
          "./layout/ClientRequestDemo"
        );
        return { Component: ClientRequestDemo };
      },
    },
    {
      // Account 整區要 Admin：子帳號先輸入 PIN
      async lazy() {
        const { AccountGate } = await import("./access/AccountGate");
        return { Component: AccountGate };
      },
      children: [
        {
          path: urls.admin.account,
          async lazy() {
            const { Account } = await import("./layout/Account");
            return { Component: Account };
          },
        },
        {
          path: urls.admin.account_info_edit,
          async lazy() {
            const { AccountInfoEdit } = await import(
              "./layout/AccountInfoEdit"
            );
            return { Component: AccountInfoEdit };
          },
        },
        {
          path: urls.admin.account_portfolio_create,
          async lazy() {
            const { AccountPortfolioCreate } = await import(
              "./layout/AccountPortfolioCreate"
            );
            return { Component: AccountPortfolioCreate };
          },
        },
        {
          path: urls.admin.account_portfolio_edit,
          async lazy() {
            const { AccountPortfolioEdit } = await import(
              "./layout/AccountPortfolioEdit"
            );
            return { Component: AccountPortfolioEdit };
          },
        },
        {
          path: urls.admin.account_know_how,
          async lazy() {
            const { AccountKnowHow } = await import("./layout/AccountKnowHow");
            return { Component: AccountKnowHow };
          },
        },
        {
          path: urls.admin.account_password_edit,
          async lazy() {
            const { AccountPasswordEdit } = await import(
              "./layout/AccountPasswordEdit"
            );
            return { Component: AccountPasswordEdit };
          },
        },
        {
          path: urls.admin.account_chatbot_color_edit,
          async lazy() {
            const { AccountChatbotColorEdit } = await import(
              "./layout/AccountChatbotColorEdit/AccountChatbotColorEdit"
            );
            return { Component: AccountChatbotColorEdit };
          },
        },
        {
          path: urls.admin.admin_dashboard,
          async lazy() {
            const { Admin } = await import("./layout/Admin");
            return { Component: Admin };
          },
        },
        {
          path: urls.admin.account_sub_account,
          async lazy() {
            const { SubAccountSettings } = await import(
              "./access/SubAccountSettings"
            );
            return { Component: SubAccountSettings };
          },
        },
      ],
    },
  ],
};
